<template lang="pug">
v-container.pa-0(fluid)
    Inicio
    Herramientas
    Servicios
    Contacto
    Video
    PiePagina
    router-view
</template>
<script>
import { mapState } from 'vuex'
export default {
    computed: {
        ruta_actual(){
            return this.$route.name
        },
        ...mapState({
            Cargando: ({Ayudas}) => Ayudas.cargando,
        }),
    },
    components: {
        Inicio:()=> import('./secciones/Inicio'),
        Herramientas:()=> import('./secciones/Herramientas'),
        Servicios:()=> import('./secciones/Servicios'),
        Contacto:()=> import('./secciones/Contacto'),
        Video:()=> import('./secciones/Video'),
        PiePagina:()=> import('./secciones/PiePagina'),

    }
}
</script>
